var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speed-info"},[_c('div',{staticClass:"speed-info__driver-name"},[_vm._v(_vm._s(_vm.driverName))]),_c('div',{class:[
            'speed-info__registration-number',
            {
                'speed-info__registration-number--online': _vm.status === 'online',
                'speed-info__registration-number--offline': _vm.status === 'offline',
            }
        ],on:{"click":_vm.goTodaysJourney}},[_vm._v(_vm._s(_vm.registrationNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }